<ng-container *ngIf="style === 'inline'">
    <ng-container *ngTemplateOutlet="addressTmpl"></ng-container>
</ng-container>

<ng-template #addressTmpl>
    <div class="container g-0">
        <div>
            <h4 class="col-12 text-dark fw-500" *ngIf="title && style === 'inline'">{{ title }}</h4>
        </div>
        <div *ngIf="style === 'modal'" class="search-address-form-header">
            <h4 class="col-12 text-dark fw-500">Add Address</h4>
        </div>

        <div class="search-address-form-body">
            <div class="mb-3" *ngIf="showCurrentAddresses && addresses.length">
                <div class="mb-b fw-500 g-0">
                    This account has existing addresses, please check before adding a new one
                </div>
                <div class="col-12 g-0">
                    <ng-select class="dark" (change)="selectExistingAddress($event)" [clearable]="false"
                        [searchable]="false">
                        <!-- <ng-option
                            [value]="address"
                            *ngFor="let address of addressResults">
                            {{ address.add1 }}
                            <span *ngIf="address.town">, {{address.town}}</span>
                            <span *ngIf="address.postcode">, {{address.postcode}}</span>
                        </ng-option> -->
                    </ng-select>
                </div>
            </div>

            <div class="mt-3 mb-3" [ngClass]="{ 'mt-3': title}" *ngIf="!manualAddress">
                <label class="input-gray-label" [ngClass]="{ 'required': requiredFields.postcode }">Enter
                    Postcode:</label>
                <div class="d-flex align-items-start g-0">
                    <div class="flex-grow-1">
                        <input type="search" class="text-input-field" placeholder="Enter postcode to search"
                            [autocomplete]="'off'" [(ngModel)]="address.postcode"
                            [ngClass]="{ 'is-invalid' : form.controls.postcode.invalid && form.controls.postcode.touched }" />
                        <div class="invalid-feedback">Postcode is required</div>
                    </div>
                    <button type="button" class="btn-styled ms-2" (click)="findAddresses()">
                        Find
                    </button>
                </div>
            </div>

            <div class="mb-3 enter-address-manually">
                <div class="col-12 g-0">
                    <a href="javascript:void(0);" (click)="manualAddressToggle()">{{
                        !manualAddress ? "Enter address
                        manually" : "Search by postcode (UK only)" }}</a>
                </div>
            </div>

            <div class="mb-4" *ngIf="addressResults.length">
                <div class="col-12 g-0">
                    <ng-select class="dark" (change)="handleAddressChange($event)" [clearable]="false"
                        [searchable]="false" [placeholder]="'Select address'">

                        <ng-option [value]="adr" *ngFor="let adr of addressResults">
                            {{ adr.line_1 }}, {{ adr.locality ? adr.locality : adr.town_or_city }}{{ adr.county ? ', ' +
                            adr.county: '' }}
                        </ng-option>
                    </ng-select>
                </div>
            </div>

            <form [formGroup]="form" autocomplete="off" *ngIf="selectedUkAddress || manualAddress || mode === 'edit'">
                <div class="row mb-4">
                    <label class="input-gray-label" [ngClass]="{ 'required': requiredFields.adr1 }">Address line
                        1</label>
                    <input type="text" class="text-input-field" formControlName="adr1" placeholder="Address line 1"
                        [ngClass]="{'is-invalid' : form.controls.adr1.invalid && form.controls.adr1.touched}" />
                    <div class="invalid-feedback">This field is mandatory</div>
                </div>
                <div class="row mb-4">
                    <div class="col-12 col-lg-6 g-0 pe-2">
                        <label class="input-gray-label" [ngClass]="{ 'required': requiredFields.adr2 }">Address line
                            2</label>
                        <input type="text" class="text-input-field" formControlName="adr2" placeholder="Address line 2"
                            [ngClass]="{'is-invalid' : form.controls.adr2.invalid && form.controls.adr2.touched}" />
                        <div class="invalid-feedback">This field is mandatory</div>
                    </div>

                    <div class="col-12 col-lg-6 g-0 ps-2">
                        <label class="input-gray-label" [ngClass]="{ 'required': requiredFields.adr3 }">Address line
                            3</label>
                        <input type="text" class="text-input-field" formControlName="adr3" placeholder="Address line 2"
                            [ngClass]="{'is-invalid' : form.controls.adr3.invalid && form.controls.adr3.touched}" />
                        <div class="invalid-feedback">This field is mandatory</div>
                    </div>
                </div>

                <div class="row mb-4">
                    <div class="col-12 col-lg-6 g-0 pe-2">
                        <label class="input-gray-label"
                            [ngClass]="{ 'required': requiredFields.town }">Town/City</label>
                        <input type="text" class="text-input-field" formControlName="town" placeholder="Town / city"
                            [ngClass]="{'is-invalid' : form.controls.town.invalid && form.controls.town.touched}" />
                        <div class="invalid-feedback">This field is mandatory</div>
                    </div>
                    <div class="col-12 col-lg-6 g-0 ps-2">
                        <label class="input-gray-label" [ngClass]="{ 'required': requiredFields.county }">County</label>
                        <input type="text" class="text-input-field" placeholder="County" formControlName="county"
                            [ngClass]="{'is-invalid' : form.controls.county.invalid && form.controls.county.touched}" />
                        <div class="invalid-feedback">This field is mandatory</div>
                    </div>
                </div>

                <div class="row mb-4" *ngIf="manualAddress">
                    <label class="input-gray-label" [ngClass]="{ 'required': requiredFields.postcode }">Postcode/Zip
                        code</label>
                    <input type="text" class="text-input-field" formControlName="postcode"
                        placeholder="Postcode/Zip code"
                        [ngClass]="{ 'is-invalid' : form.controls.postcode.invalid && form.controls.postcode.touched }">
                    <div class="invalid-feedback">This field is mandatory</div>
                </div>
                <div class="row selector-row mb-4" *ngIf="manualAddress">
                    <label class="input-gray-label" [ngClass]="{ 'required': requiredFields.country }">Country</label>
                    <ng-select class="dd-select" placeholder="Select country" [ngModel]="address.country"
                        [ngModelOptions]="{standalone: true}" (change)="handleCountryChange($event)" [clearable]="false"
                        [searchable]="false"
                        [ngClass]="{ 'is-invalid' : form.controls.country.invalid && form.controls.country.touched }">
                        <ng-option *ngFor="let country of countries" [value]="country.id">{{ country.id }} - {{
                            country.countryName }}</ng-option>
                    </ng-select>
                    <div class="invalid-feedback">This field is mandatory</div>
                </div>

            </form>
        </div>
    </div>
</ng-template>